export enum EventsEnum {
  // ---------- Root Events ----------
  // Core
  Started = 'started',
  Loaded = 'loaded',
  Tick = 'tick',

  // Human
  HumanReady = 'human.ready',
  HumanStarted = 'started',
  Error = 'error',
  HumanError = 'human.error',

  // Private logging
  LogDebug = '_log.debug',
  LogError = '_log.error',
  LogInfo = '_log.info',
  LogWarn = '_log.warn',
  SceneLoaded = 'scene.loaded',
  HumanProgress = 'human.progress',

  // ---------- Namespaced Events ----------
  // Annotations
  AnnotationsCreated = 'annotations.created',
  AnnotationsDestroyed = 'annotations.destroyed',
  AnnotationsHidden = 'annotations.hidden',
  AnnotationsShown = 'annotations.shown',

  // Assets
  AssetsLoadFinish = 'assets.load.finish',
  AssetsLoadProgress = 'assets.load.progress',
  AssetsLoadStart = 'assets.load.start',

  // Camera
  CameraRested = 'camera.rested',
  CameraUpdated = 'camera.updated',

  // Hotspots
  HotspotsDisplayUpdated = 'hotspots.displayUpdated',
  HotspotsEntered = 'hotspots.entered',
  HotspotsLeft = 'hotspots.left',
  HotspotsPicked = 'hotspots.picked',
  HotspotsPositionUpdated = 'hotspots.positionUpdated',

  // Labels API events
  LabelsCreated = 'labels.created',
  LabelsUpdated = 'labels.updated',
  LabelsMoved = 'labels.moved',
  LabelsDestroyed = 'labels.destroyed',
  LabelsChapterInfo = 'labels.chapterInfo',
  LabelsShown = 'labels.shown',
  LabelsHidden = 'labels.hidden',
  LabelsEnabled = 'labels.enabled',
  LabelsDisabled = 'labels.disabled',
  LabelsEntered = 'labels.entered',
  LabelsLeft = 'labels.left',
  LabelsPicked = 'labels.picked',

  // Modules
  ModuleInteractive = 'module.interactive',
  ModulesActivateFinish = 'modules.activate.finish',
  ModulesCreateFinish = 'modules.create.finish',
  ModulesDestroyFinish = 'modules.destroy.finish',

  // Pick
  PickPicked = 'pick.picked',

  // Quiz
  QuizEntered = 'quiz.entered',
  QuizExited = 'quiz.exited',
  QuizQuestionLoaded = 'quiz.questionLoaded',
  QuizAnswerSelected = 'quiz.answerSelected',
  QuizAnswerSubmitted = 'quiz.answerSubmitted',
  QuizCompleted = 'quiz.completed',

  // Scene
  SceneMarkersUpdated = 'scene.markers.updated',
  SceneObjectRenderable = 'scene.objectRenderable',
  SceneObjectsSelected = 'scene.objectsSelected',
  SceneObjectsShown = 'scene.objectsShown',
  ScenePicked = 'scene.picked',
  SceneRestored = 'scene.restored',
  SceneXrayEnabled = 'scene.xrayEnabled',
  SceneXrayDisabled = 'scene.xrayDisabled',
  
  // internal only - used because the API lib only fires human.ready once, even though we can do things like scene.load()
  SceneReady = 'scene.ready', 

  // Timeline
  TimelineChaptersActivated = 'timeline.chapters.activated',
  TimelineChaptersActivateFinish = 'timeline.chapters.activate.finish',
  TimelineChaptersActivateStart = 'timeline.chapters.activate.start',
  TimelineChapterTransition = 'timeline.chapterTransition',
  TimelinePlaying = 'timeline.playing',
  TimelineScrubbed = 'timeline.scrubbed',
  TimelinePlayed = 'timeline.played',
  TimelineStopped = 'timeline.stopped',
  TimelinePaused = 'timeline.paused',
  TimelineUnpaused = 'timeline.unpaused',
  TimelineCompleted = 'timeline.completed',

  // Graph
  GraphAssetAttachFinish = 'graph.assetAttach.finish',
  TweenVisibilityUpdate = 'TweenVisibilityUpdate',
  
  // Native Android iOS webapp events
  NativeDeleteData = 'native.deleteData',
  NativeUpgrade = 'native.upgrade',
  NativeRestore = 'native.restore',
  NativeShare = 'native.share',
  NativeGoogleSignUp = 'native.googleSignUp'
}
